<div id="main" class="report">

  <ng-container *ngIf="isLoading; else loaded">

    <div class="process-header">
      <h1>Proszę czekać</h1>
    </div>

    <div class="process-content">
      <div class="inner">
        <p>Pobieram dane...</p>
      </div>
    </div>

  </ng-container>

  <ng-template #loaded>

    <ng-container *ngIf="report; else unavailable">

      <div class="process-header">
        <h1>Sytuacja osoby zmarłej w publicznych bazach danych</h1>
      </div>

      <div class="process-content">

        <div class="inner">

          <div class="report">

            <section *ngIf="report.status !== 'PROCESSED'" class="report-header-box">
              <div class="report-icon-wrapper">
                <span class="material-symbols-outlined report-icon-pending">update</span>
              </div>

              <div class="report-header-box__details">
                <h3 class="report-header-box__report-number">
                  Raport w trakcie realizacji
                </h3>

                <p>
                  Twój raport jest aktualnie generowany.
                  Powiadomimy Cię, gdy będzie gotowy do pobrania.
                </p>

                <div class="progress">
                  <div class="progress__bar" [style.width.%]="progress"></div>
                </div>

                <div class="progress__footer">
                  <span>Trwa generowanie raportu...</span>
                  <span>{{ progress }}%</span>
                </div>
              </div>

              <div class="report-header-box__actions">
                <div class="report-header-box__report-status">
                  <strong>STATUS:</strong>

                  <span class="badge badge-warning u-margin-left-20">
                    W REALIZACJI
                  </span>
                </div>
              </div>

              <div class="report-header-box__report-notice">
                <span>Dane są pozyskiwane z publicznych baz danych.</span>

                <span>
                  Nie zamykaj tej strony - powiadomimy Cię, gdy raport będzie gotowy.
                </span>
              </div>
            </section>

            <section
              *ngIf="report.status !== 'PROCESSED' && reportDeleyed"
              class="report-header-box report-header-box--info report-notice"
            >
              <div class="report-icon-wrapper">
                <span class="material-symbols-outlined report-icon">info</span>
              </div>

              <div class="report-header-box__details">
                <p>
                  Realizacja Twojego raportu nadal trwa ze względu na czasowy brak
                  odpowiedzi niektórych rejestrów rządowych.
                </p>

                <p>
                  W rzadkich przypadkach czasowej niedostępności rejestrów,
                  tworzenie raportu może potrwać do 72 godzin.
                </p>
              </div>
            </section>

            <section
              *ngIf="report.status === 'PROCESSED'"
              class="report-header-box"
            >

              <div class="report-icon-wrapper">
                <span class="material-symbols-outlined report-icon">
                  assignment
                </span>
              </div>

              <div class="report-header-box__details">

                <h3 class="report-header-box__report-number">
                  {{ report.reportNumber }}
                </h3>

                <p class="report-header-box__desesed">
                  <strong>
                    Osoba zmarła:
                    {{ report.deceased.name }}
                    {{ report.deceased.lastName }}
                  </strong>
                </p>

                <p class="report-header-box__desesed">
                  <strong>PESEL:</strong>
                  {{ report.deceased.peselNumber }}
                </p>

                <p class="report-header-box__desesed">
                  <strong>NIP:</strong>
                  {{
                    report.deceased.taxId === 'XXXXXXXXXX'
                      ? '(nie podano)'
                      : report.deceased.taxId
                  }}
                </p>

                <p class="report-header-box__death-date">
                  <strong>Data zgonu:</strong>
                  {{ report.deceased.dateOfDeath | date: 'longDate' }}
                </p>

              </div>

              <div class="report-header-box__actions">

                <button
                  class="cta primary icon-button download-btn"
                  (click)="generatePdf()"
                >
                  Pobierz raport
                  <span class="download-icon" aria-hidden="true"></span>
                </button>

                <div class="report-header-box__report-status">

                  <strong>STATUS:</strong>

                  <span
                    *ngIf="report.status === 'PROCESSED'"
                    class="badge badge-success u-margin-left-20"
                  >
                    {{ report.status | reportStatus }}
                  </span>

                  <span
                    *ngIf="report.status && report.status !== 'PROCESSED'"
                    class="badge badge-warning u-margin-left-20"
                  >
                    {{ report.status | reportStatus }}
                  </span>

                </div>

                <div>
                  <strong>Zamawiający:</strong>
                  {{ report.order.client.name }}
                  {{ report.order.client.lastName }}
                </div>

              </div>

              <div class="report-header-box__report-notice">

                <span>
                  Wygenerowano na podstawie informacji z publicznych baz danych.
                </span>

                <span>
                  Data wygenerowania informacji z baz danych:
                  {{ report.databaseStatusOn | date:'d MMMM y, HH:mm:ss' }}
                </span>

              </div>

            </section>

            <main>
              <section class="report-section">
                <h3>Baza danych</h3>
                <h3><span class="result-header">Wynik</span></h3>

                <div class="question">
                  <strong>Centralna Ewidencja Działalności Gospodarczej</strong><br/><br/>
                  Czy osoba zmarła prowadziła dzialalność gospodarczą?<br/>
                  <span>Prowadzenie działalności gospodarczej wiąże się z możliwością występowania aktywów, ale również z możliwością występowania zadłużenia w stosunku do administracji publicznej np. ZUS, US lub kontrahentów.</span>
                </div>
                <div class="answer">
                  <span *ngIf="report.result.ceidg === 'PENDING'" class="loader"><strong>GENERUJĘ</strong></span>
                  <strong *ngIf="report.result.ceidg !== 'PENDING'" [innerHTML]="mapReportResult(report.result.ceidg)"></strong>
                  <span *ngIf="report.result.ceidg === 'SKIPPED'">(nie podano NIP)</span>
                </div>


                <div class="question">
                  <strong>Krajowy Rejestr Sądowy</strong><br/><br/>
                  Czy osoba zmarła posiadała prawa własności np. udziały lub akcje w spółkach?*<br/>
                  <span>Posiadanie udziałów w spółkach jest aktywem, jednak jest to uzależnione od kondycji danej spółki.</span>
                </div>
                <div class="answer">
                  <span *ngIf="report.result.krs.propertyRights === 'PENDING'" class="loader"><strong>GENERUJĘ</strong></span>
                  <strong
                    *ngIf="report.result.krs.propertyRights !== 'PENDING'" [innerHTML]="mapReportResult(report.result.krs.propertyRights)"></strong>
                  <span *ngIf="report.result.krs.propertyRights === 'SKIPPED'">(nie podano NIP)</span>
                </div>

                <div class="question">
                  <strong>Krajowy Rejestr Sądowy</strong><br/><br/>
                  Czy osoba zmarła pełniła funkcje we władzach spółki np. jako członek zarządu spółki lub jej
                  wspólnik?*<br/>
                  <span>Pełnienie niektórych funkcji w spółce może się wiązać z odpowiedzialnością osobistą za zobowiązania spółki. Może to być potencjalne źródło długów osoby zmarłej.</span>
                </div>
                <div class="answer">
                  <span *ngIf="report.result.krs.companyAuthorities === 'PENDING'" class="loader"><strong>GENERUJĘ</strong></span>
                  <strong
                    *ngIf="report.result.krs.companyAuthorities !== 'PENDING'" [innerHTML]="mapReportResult(report.result.krs.companyAuthorities)"></strong>
                  <span *ngIf="report.result.krs.companyAuthorities === 'SKIPPED'">(nie podano NIP)</span>
                </div>

                <div class="question">
                  <strong>Centralny Rejestr Beneficjentów Rzeczywistych</strong><br/><br/>
                  Czy osoba zmarła jest beneficjentem spółki, trustu lub fundacji rodzinnej?<br/>
                  <span>Występowanie osoby zmarłej w tym rejestrze może oznaczać posiadanie przez nią aktywów.</span>
                </div>
                <div class="answer">
                  <span *ngIf="report.result.crbr === 'PENDING'" class="loader"><strong>GENERUJĘ</strong></span>
                  <strong *ngIf="report.result.crbr !== 'PENDING'" [innerHTML]="mapReportResult(report.result.crbr)"></strong>
                  <span *ngIf="report.result.crbr === 'SKIPPED'">(nie podano NIP)</span>
                </div>

                <div class="question">
                  <strong>Wykaz Podatników Podatku VAT</strong><br/><br/>
                  Czy osoba zmarła występuje w Wykazie podatników podatku VAT, czyli białej liście podatników VAT?<br/>
                  <span>To jest informacja czy osoba zmarła kiedykolwiek posidała status podatku VAT (czy występowała w rejestrze VAT). Rodzaj tego statusu może oznaczać posiadanie aktywów albo zobowiązań np. wobec Urzędu Skarbowego.</span>
                </div>
                <div class="answer">
                  <span *ngIf="report.result.vatWl === 'PENDING'" class="loader"><strong>GENERUJĘ</strong></span>
                  <strong *ngIf="report.result.vatWl !== 'PENDING'" [innerHTML]="mapReportResult(report.result.vatWl)"></strong>
                  <span *ngIf="report.result.vatWl === 'SKIPPED'">(nie podano NIP)</span>
                </div>

                <div class="question">
                  <strong>Krajowy Rejestr Zadłużonych</strong><br/><br/>
                  Czy osoba zmarła występuje w Krajowym Rejestrze Zadłużonych?<br/>
                  <span>Występowanie osoby zmarłej w tym rejestrze może oznaczać posiadanie przez nią długów. To jest bardzo istotna informacja.</span>
                </div>
                <div class="answer">
                  <span *ngIf="report.result.krz === 'PENDING'" class="loader"><strong>GENERUJĘ</strong></span>
                  <strong *ngIf="report.result.krz !== 'PENDING'" [innerHTML]="mapReportResult(report.result.krz)"></strong>
                  <span *ngIf="report.result.krz === 'SKIPPED'">(nie podano NIP)</span>
                </div>

                <div class="question">
                  <strong>SUDOP</strong><br/><br/>
                  Czy osoba zmarła otrzymała pomoc publiczną?<br/>
                  <span>Pewne formy pomocy publicznej np. odroczenie zapłaty mandatu lub kary mogą być źrodłem długów osoby zmarłej, jeżeli nie zostały zapłacone.</span>
                </div>
                <div class="answer">
                  <span *ngIf="report.result.sudop === 'PENDING'" class="loader"><strong>GENERUJĘ</strong></span>
                  <strong *ngIf="report.result.sudop !== 'PENDING'" [innerHTML]="mapReportResult(report.result.sudop)"></strong>
                  <span *ngIf="report.result.sudop === 'SKIPPED'">(nie podano NIP)</span>
                </div>

                <div class="question">
                  <strong>Monitor Sądowy i Gospodarczy</strong><br/><br/>
                  Czy osoba zmarła występuje w Monitorze Sądowym i Gospodarczym?<br/>
                  <span>Występowanie osoby zmarłej w tym rejestrze może oznaczać posiadanie przez nią długów. To jest bardzo istotna informacja.</span>

                </div>
                <div class="answer">
                  <span *ngIf="report.result.msig === 'PENDING'" class="loader"><strong>GENERUJĘ</strong></span>
                  <strong *ngIf="report.result.msig !== 'PENDING'" [innerHTML]="mapReportResult(report.result.msig)"></strong>
                  <span *ngIf="report.result.msig === 'SKIPPED'">(nie podano NIP)</span>
                </div>
              </section>

              <section class="report-note">
                <p class="report-notice">*Pamiętaj, że jeżeli osoba zmarła posiadała samodzielnie lub łącznie z innymi
                  osobami mniej niż 10% udziałów spółki z ograniczoną odpowiedzialnością lub nie posiadała wszystkich akcji
                  spółki akcyjnej to takie informacje nie są publikowane i nie są widoczne w Dziale 1 KRS. Dlatego nawet
                  jeżeli powyżej nie ukazuje się żadna spółka z ograniczoną odpowiedzialnością lub spółka akcyjna to nie
                  oznacza to, że osoba zmarła nie była udziałowcem lub akcjonariuszem żadnego przedsiębiorstwa.</p>
              </section>

              <section class="report-definitions">
                <h3>Definicje</h3>

                <article>
                  <strong>Beneficjent rzeczywisty</strong>
                  <span>Osoba, która sprawowała kontrolę nad danym podmiotem np. spółką lub miała decydujący wpływ na jego
            czynności lub działania, była udziałowcem lub akcjonariuszem mającym prawo własności więcej niż 25%
            ogólnej liczby udziałów lub akcji, dysponowała więcej niż 25% ogólnej liczby głosów w organie
            stanowiącym spółki lub sprawowała kontrolę nad osobą prawną lub osobami prawnymi w sposób opisany w art.
            2 ust. 2 pkt 1 ustawy AML (Dz.U. 2022 poz. 593), sprawowała kontrolę nad osobą prawną przez posiadanie w
            stosunku do niej uprawnień wymienionych w art. 3 ust. 1 pkt 37 ustawy z dnia 29 września 1994 r. o
            rachunkowości (Dz. U. z 2019 r. poz. 351), była fundatorem w rozumieniu ustawy z dnia 26 stycznia 2023
            r. o fundacji rodzinnej (Dz. U. poz. 326) albo beneficjentem w rozumieniu tej ustawy, była założycielem
            trustu, jego beneficjentem lub sprawowała kontrolę nad trustem.</span>
                </article>

                <article>
                  <strong>Aktywa</strong>
                  <span>Zasoby majątkowe o określonej wartości lub inaczej majątek np. maszyny, pojazdy, nieruchomości,
              wierzytelności, środki na rachunkach bankowych, udziały w spółkach, itp.</span>
                </article>

                <article>
                  <strong>Pasywa</strong>
                  <span>Zasoby zmniejszające majątek lub takie, z których finansowany jest majątek np. kredyty, pożyczki oraz
              długi i zobowiązaniach wobec podmiotów, którym osoba zmarła w jakiś sposób była winna pieniądze.</span>
                </article>
              </section>

              <section class="report-definitions">
                <h3>Jak interpretować powyższe informacje?</h3>
                <article>

              <span>Ten raport zawiera informacje, czy osoba zmarła kiedykolwiek występowała w Centralnej Ewidencji i Informacji o Działalności Gospodarczej lub w Krajowym Rejestrze Sądowym. Nie zawsze jest to informacja, czy osoba zmarła znajdowała się w tych rejestrach w dniu jej śmierci. Informacja, że osoba zmarła prowadziła działalność gospodarczą może oznaczać, że prowadziła ją np. 10 lat temu lub 3 miesiące temu, ale nie została jeszcze wykreślona z CEIDG.
              Tak samo należy interpretować informację z Krajowego Rejestru Sądowego. Informacja, że osoba zmarła posiadała udziały lub akcje w spółkach oznacza, że mogła posiadać je 10 lat temu lub 3 miesiące temu, ale tych udziałów być może już nie posiada.
              Niemniej jest to bardzo wartościowa informacja dla potencjalnego spadkobiercy, ponieważ może oznaczać posiadanie przez osobę zmarłą aktywów lub długów. Jeżeli chcesz uzyskać bardziej szczegółowe informacje o sytuacji osoby zmarłej w tych rejestrach np. o szczegółach prowadzonej jednoosobowej działalność gospodarczej, czy na temat tego w jakich konkretnie spółkach posiadała udziały lub w jakiej ilości możesz je otrzymać w Raporcie Rozszerzonym.</span>

                </article>

              </section>
            </main>

          </div>

        </div>

      </div>

    </ng-container>

  </ng-template>

  <ng-template #unavailable>

    <div class="process-header">
      <h1>Raport niedostępny</h1>
    </div>

    <div class="process-content">

      <div class="inner">

        <div class="report-expired">

          <h4>
            Ze względów bezpieczeństwa raport jest dostępny przez 72 godziny
            od momentu utworzenia.

            Jeśli ten czas minął, dostęp do raportu został automatycznie
            zakończony.

            Raport został usunięty z systemu.

            Aby sprawdzić aktualne dane osoby zmarłej możesz zamówić nowy raport.
          </h4>

          <a
            class="cta cta--bold"
            [routerLink]="['/']"
            fragment="products"
            [ngxScrollTo]="'#products'"
            [ngxScrollToOffset]="-200"
          >
            Zamów nowy raport
          </a>

        </div>

      </div>

    </div>

  </ng-template>

</div>
